export const clientCssVars = {
  '--coze-z-index-iframe': 1000,
};
